import React, { useEffect, useState } from 'react';
import Button from '../button';
import Input from '../input';
// import BannerBGImg from '../../../assets/images/banner/bg.svg';
// import BannerBGImg2 from '../../../assets/images/banner/bg_2.svg';
import routeDetails from '../../../redux/actions/route-details/route-details';
import getAssets from '../../../image-loader';
import SearchIcon from '../../../assets/icons/search-icon.svg';
// import PlayIcon from '../../../assets/icons/play.svg';
import SearchSuggestion from '../search-suggestions';

import { Container } from 'react-bootstrap';
import { withRouter } from "react-router";
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

/**
 * function representing banner component
 */
function Banner({ location, history }) {

  const [timeout, setTime] = useState(0);

  const [isSearching, setIsSearching] = useState(false);

  const [searchText, setSearchText] = useState(false);

  const [filteredData, setFilteredData] = useState([]);

  const [isBaseRoute, setIsBaseRoute] = useState(false);

  const [bannerImg, setBannerImg] = useState();

  const { pathname } = useSelector(state => state.routeDetails.data);

  const { t: trans } = useTranslation();

  const { products } = useSelector(state => state);

  const dispatch = useDispatch();

  const search = (text) => {
    if (!text || !text.trim().length) { return [] }
    if (products.data) {
      return products.data.filter(item => {
        return (item.name || '').toLowerCase().includes(text.toLowerCase()) ||
          (item.label || '').toLowerCase().includes(text.toLowerCase()) ||
          (item.description || '').toLowerCase().includes(text.toLowerCase()) ||
          (item.vendor || '').toLowerCase().includes(text.toLowerCase()) ||
          (item.categoryName || '').toLowerCase().includes(text.toLowerCase())
      });
    }
  }

  useEffect(() => {
    (async function getFiles() {
      if (!bannerImg) {
        setBannerImg(await (await getAssets()).banner.default);
      }
    })();
  }, [bannerImg])

  useEffect(() => {
    setIsBaseRoute(location.pathname === '/');
    dispatch(routeDetails(location));
    setIsSearching(false);
  }, [location, dispatch, isBaseRoute])

  const styles = {
    height: isBaseRoute ? 'auto' : 200,
    // backgroundImage: `url(${isBaseRoute ? BannerBGImg : BannerBGImg2})`
  }

  const handleSearch = (e) => {
    let txt = e.target.value;
    setSearchText(txt);
    if (timeout) clearTimeout(timeout);
    setTime(setTimeout(() => {
      setIsSearching(txt ? true : false);
      setFilteredData([...search(txt)]);
    }, 500));
  }

  const navigateToProduct = (id) => {
    setIsSearching(false);
    history.push(`/integration/${id}`);
  }

  return (
    <div className="banner" style={styles}>
      <Container className="banner-container">
        {pathname === '/'
          ?
          <header className="masthead layout-2col-svg-right bg-cover" >
            <div className="row m-0 justify-content-between">
              <div className="col-xl-6 order-xl-2 p-4 p-xl-0 d-flex align-items-center justify-content-center">
                <img src={bannerImg} width="700" className="img-fluid mx-auto" alt="bannerimg" />
              </div>
              <div className="col-xl-6 order-xl-1 p-4 p-xl-0 flex-fill d-flex align-items-center text-light ">
                <div className="content mx-auto text-center text-xl-left">
                  <h1 className="underline-center underline-xl-left">{trans('banner.main-title')}</h1>
                  <div className="description">{trans('banner.sub-title')}</div>
                  {/* <a className="btn-ue round btn btn-primary" href="https://login.unieconomy.no/Account/Login?ReturnUrl=%2Fconnect%2Fauthorize%2Fcallback%3Fclient_id%3D244088c3-a9a5-8713-9664-213ad70023bc%26redirect_uri%3Dhttps%253A%252F%252Funieconomy.no%252Fassets%252Fauth.html%26response_type%3Did_token%2520token%26scope%3Dprofile%2520openid%2520AppFramework%26state%3Dbe72c0afafa448e5b9b722ee09fa9cd3%26nonce%3Db334109e7cb64891a6d1f6f3ace4ee52" target="_blank">Logg på Uni Economy<i className="fas fa-external-link-alt"></i></a> */}
                  {false &&
                    <Button classes="btn-ue round btn btn-primary" text={trans('banner.watch-demo-btn')} variant="outline-dark" />
                  }
                </div>
              </div>
            </div>
          </header>
          :
          <div className="content-wrapper with-padding">
            <div className='search-block'>
              <Input icon={SearchIcon} type="text"
                onChange={handleSearch}
                placeHolder={trans('search.search-input')} />
              <SearchSuggestion onClick={navigateToProduct} searchText={searchText} isSearch={isSearching} products={filteredData} />
            </div>
          </div>
        }
      </Container>
    </div>
  )
}

export default withRouter(Banner);